import React from "react"
import {
  Autocomplete,
  Box,
  FormControl,
  FormControlLabel,
  FormHelperText,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select, TextField,
  Typography, Button
} from "@mui/material"
import theme from "../../../../styles/theme/theme.const"
import yesImg from "../../../../assets/images/fresh-policy-icon.svg"
import noImg from "../../../../assets/images/renewal-policy-icon.svg"
import flatImg from "../../../../assets/images/flat-icon.svg"
import gradedImg from "../../../../assets/images/graded-icon.svg"
import tryCalcImg from "../../../../assets/images/notSure.svg"
import sumInsuredList from "../../../../constants/sum-insured.const"
import { locationsUSA } from "../../../../constants/locations-usa.const"
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import validationSchema from './validation-scheme'
import FormProvider from "../../../hook-form/FormProvider";

const styles = {
  checkboxControl: {
    width: "100%"
  },
  checkbox: {
    position: "relative",
    padding: 4,
    border: `1px solid ${theme.palette.grey["400"]}`,
    borderRadius: 4,
    margin: "0 0 16px 0",
    flexDirection: "row-reverse",
    justifyContent: "space-between",
    color: theme.palette.primary.dark,

    "&.start.MuiFormControlLabel-root": {
      alignItems: "flex-start"
    },

    "& h4": {
      color: theme.palette.grey["500"]
    },

    "& .MuiRadio-root": {
      padding: 0
    }
  },

  tryCalc: {
    border: `1px solid ${theme.palette.primary.main}`,
    padding: "19px 0 19px 60px",
    borderRadius: 4,
    backgroundImage: `url(${tryCalcImg})`,
    backgroundColor: theme.palette.grey["200"],
    backgroundRepeat: "no-repeat",
    backgroundPosition: "10px 12px"
  },

  tryButton: {
    color: theme.palette.primary.main,
    cursor: "pointer",
    width: "max-content",
    marginRight: 8
  }
};

const StepTwo = ({ data, activeStep, handleBack, handleNext, STEPS }) => {
  const methods = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      ...data,
    },

  });
  const {
    watch,
    setValue,
    handleSubmit,
    setError,
    formState: { errors },
  } = methods;

  const values = watch();
  // console.log('values===2', values)
  const onSubmit = async (data) => {
    // console.log('data====2>', data)
    try {
      handleNext(data)
      // reset();
    } catch (error) {
      console.error(error);
    }
  };
  const handleChange = (event) => {
    console.log('event.target.name', event.target.name)
    setValue(event.target.name, event.target.value);
  };
  const getLocation = (location) => typeof location === "object" ? `${location.name} (${location.state})` : location

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Typography style={{ paddingTop: 10, paddingBottom: 20 }} variant='h3' >{"Buying Group Health Insurance for the first time?"}</Typography>
      <Box display={"flex"} flexDirection={{ xs: "column" }} justifyContent={{ lg: "space-between" }}>
        <Box maxWidth={"100%"}>
          <Box mb={5}>
            <FormControl
              required={true}
              error={!!errors.firstTime}
              onChange={handleChange}
              sx={styles.checkboxControl}
            >
              <RadioGroup name="firstTime" value={values.firstTime}>
                <FormControlLabel sx={styles.checkbox} value="Yes" control={<Radio />} label={
                  <Box display={"flex"} alignItems={"center"}>
                    <img src={yesImg} alt="YES" />
                    <Box ml={4}>
                      <Typography>Yes</Typography>
                      <Typography variant={"h4"}>Buying for the first time</Typography>
                    </Box>
                  </Box>
                } />
                <FormControlLabel sx={styles.checkbox} value="No" control={<Radio />} label={
                  <Box display={"flex"} alignItems={"center"}>
                    <img src={noImg} alt="YES" />
                    <Box ml={4}>
                      <Typography>No</Typography>
                      <Typography variant={"h4"}>Existing policy is expiring</Typography>
                    </Box>
                  </Box>
                } />
              </RadioGroup>
              {errors.firstTime && <FormHelperText>{errors.firstTime.message}</FormHelperText>}
            </FormControl>
          </Box>
          <Box mb={8}>
            <Box mb={3}>
              <Typography>Select states</Typography>
            </Box>
            <Autocomplete
              multiple
              id="locationUSA"
              options={locationsUSA}
              getOptionLabel={getLocation}
              onChange={(e, value) => {
                const updatedValues = value.map(getLocation)
                setValue("locationUSA", updatedValues)
              }}
              onFocus={() => setError("locationUSA", "")}
              name={"locationUSA"}
              value={values.locationUSA || []}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  label="Locations"
                />
              )}
            />
                            {errors?.locationUSA && <FormHelperText>{errors?.locationUSA.message}</FormHelperText>}

          </Box>
          {values.firstTime === "Yes" && (
            <Box>
              <Box mb={5}>
                <FormControl
                  required={true}
                  error={!!errors.sumInsuredType}
                  onChange={handleChange}
                  sx={styles.checkboxControl}
                >
                  <Box mb={3}>
                    <Typography className={"subtitle"}>Select Sum Insured Type</Typography>
                  </Box>
                  <RadioGroup name="sumInsuredType" value={values.sumInsuredType}>
                    <FormControlLabel
                      className={"start"}
                      sx={styles.checkbox}
                      value="Flat"
                      control={<Radio />}
                      label={
                        <Box display={"flex"} alignItems={"center"}>
                          <img src={flatImg} alt="Flat" />
                          <Box ml={4}>
                            <Typography>Flat</Typography>
                            <Typography variant={"h4"}>Common sum-insured for all members in the
                              policy</Typography>
                          </Box>
                        </Box>
                      } />
                    <FormControlLabel
                      className={"start"}
                      sx={styles.checkbox}
                      value="Graded"
                      control={<Radio />}
                      label={
                        <Box display={"flex"} alignItems={"center"}>
                          <img src={gradedImg} alt="Graded" />
                          <Box ml={4}>
                            <Typography>Graded</Typography>
                            <Typography variant={"h4"}>Different sum-insured for different members in the
                              policy</Typography>
                          </Box>
                        </Box>
                      } />
                  </RadioGroup>
                  {errors.sumInsuredType && <FormHelperText>{errors.sumInsuredType.message}</FormHelperText>}
                </FormControl>
              </Box>
              {values.sumInsuredType === "Flat" && (
                <Box mb={8}>
                  <Box mb={5}>
                    <Box mb={3}>
                      <Typography>How much sum insured do you want per employee?</Typography>
                    </Box>
                    <FormControl fullWidth>
                      <InputLabel id="sumInsured">Sum Insured</InputLabel>
                      <Select
                        labelId="sumInsured"
                        id="sumInsured"
                        label="Sum Insured"
                        name={"sumInsured"}
                        value={values.sumInsured || "1 Lac"}
                        onChange={handleChange}
                      >
                        {sumInsuredList.map((item) => (
                          <MenuItem key={item.id} value={item.value}>{item.value}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                  {/* <Box sx={styles.tryCalc}>
                    <Typography color={theme.palette.primary.dark} variant={"body2"}>Not sure about the sum
                      insured?</Typography>
                    <Typography sx={styles.tryButton} variant={"body2"} onClick={handleDialogOpen}>Try
                      calculator</Typography>
                  </Box> */}
                </Box>
              )}
            </Box>
          )}
        </Box>
        <Box sx={{ textAlign: 'center' }}>
          {activeStep !== 0 && <Button variant="contained" color="primary" style={{
            borderRadius: 24,
            paddingLeft: 20,
            paddingRight: 20, paddingTop: 10,
            paddingBottom: 10,            width:"130px"

          }}
            disabled={activeStep === 0} onClick={handleBack} sx={{ mr: 1 }}>
            Back
          </Button>}
          <Button variant="contained" type='submit' color="success" style={{
            borderRadius: 24,
            paddingLeft: 24,
            paddingRight: 24,
            paddingTop: 10,
            paddingBottom: 10,            width:"130px"

          }}
            // onClick={handleNext}
            sx={{ mr: 1 }}>
            {activeStep === STEPS.length - 1 ? 'Submit' : 'Continue'}
          </Button>
        </Box>
      </Box>
    </FormProvider>
  )
}

export default StepTwo